import React from "react";
import "./Footer.css";
import Facebook from "../socials/Facebook";
import Line from "../socials/Line";
import AnchorLink from "react-anchor-link-smooth-scroll";

const Footer = () => {

    return (
        <div id="footer" className="footer">
            <AnchorLink href="#impression" className="logo" />
            <div className="socials">
                <a href="https://www.facebook.com/rinpasaloncalm" target="_blank" rel="noreferrer" className="facebook"><Facebook className={"facebook-icon"} width={30} height={30} fill={"#f4cfcf"} /></a>
                <a href="https://page.line.me/474qslor" target="_blank" rel="noreferrer" className="line"><Line className={"line-icon"} width={30} height={30} fill={"#f4cfcf"} /></a>
            </div>
            <span className="address">大分市坂ノ市里２１７９番地</span>
            <div className="clear" />
            <span className="copyright" dangerouslySetInnerHTML={{ "__html": "&copy;2022 サロンCalm" }} />
        </div>
    )
}

export default Footer